/* Truck Covers MN truck fitment (our own, replaces the Convermax app).
   Data: an index built nightly from the product metafield convermax.fitment and stored as
   Shopify Files (tcmnfit-<build>-<handle>.json on cdn.shopify.com). One shard is fetched at a time
   and kept in localStorage for the current index version (shop metafield tcmn.fit_version).
     meta        vehicles, collections, brands, per-collection counts, shard handles
     m-...-<n>   parts and fitment rows for one make/model
     u-<n>       universal-fit parts
   Provides:
     - window.TcmnFit: vehicle store, data access and a Convermax-style search()
     - the old Convermax search.json URL answered locally, so lw-fit.js keeps working unchanged
     - the Year / Make / Model / Trim picker ([data-tcmn-ymm])
     - the "parts for your truck" results page ([data-tcmn-results], /pages/search)
     - the product page fit check ([data-tcmn-product-fit]) and fitment table ([data-tcmn-fit-table]) */
(function () {
  'use strict';

  var CFG = window.TCMN_FIT || {};
  var VER = String(CFG.v || '0');
  /* Shards are Shopify Files named tcmnfit-<build>-<handle>.json (uploaded by the index rebuild). */
  var FILES = CFG.files || 'https://cdn.shopify.com/s/files/1/0803/2872/0611/files/';
  var EXT = CFG.ext || 'json';
  var KEY = 'lakewood:selected-vehicle:v1';
  var CM_API = 'https://gitiuy-fk.myconvermax.com/search.json';
  var MIN_YEAR = 2008;
  var POPULAR = ['Ford', 'Chevrolet', 'GMC', 'Toyota', 'Ram'];
  var PHONE = '(218) 308-0045', TEL = 'tel:2183080045';

  /* ---------------- small helpers ---------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(n) {
    n = Number(n);
    return isFinite(n) ? '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '';
  }
  function imgUrl(u, w) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 600);
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function squash(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function brandName(v) {
    return ({ 'Gatorback by Truck Hardware': 'Gatorback', 'RealTruck AMP Research': 'AMP Research', 'RealTruck BackRack': 'BackRack',
      'B&W Trailer Hitches': 'B&W', 'BAK Industries': 'BAK' })[v] || v || '';
  }

  /* ---------------- vehicle store (shared with lakewood.js and lw-fit.js) ---------------- */
  function getVehicle() {
    try {
      var v = JSON.parse(window.localStorage.getItem(KEY) || 'null');
      return v && v.year && v.make && v.model ? v : null;
    } catch (e) { return null; }
  }
  function setVehicle(v) {
    try {
      if (v) window.localStorage.setItem(KEY, JSON.stringify({ year: String(v.year), make: v.make, model: v.model, submodel: v.submodel || '' }));
      else window.localStorage.removeItem(KEY);
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('lakewood:vehiclechange', { detail: v || null }));
  }
  function label(v) { return v ? [v.year, v.make, v.model, v.submodel].filter(Boolean).join(' ') : ''; }
  function resultsUrl(v) {
    var p = new URLSearchParams();
    p.set('year', v.year); p.set('make', v.make); p.set('model', v.model);
    if (v.submodel) p.set('submodel', v.submodel);
    return '/pages/search?' + p.toString();
  }

  /* ---------------- shard loading ---------------- */
  var mem = {};
  (function prune() {
    try {
      for (var i = window.localStorage.length - 1; i >= 0; i--) {
        var k = window.localStorage.key(i);
        if (k && k.indexOf('tcmnfit:') === 0 && k.indexOf('tcmnfit:' + VER + ':') !== 0) window.localStorage.removeItem(k);
      }
    } catch (e) {}
  })();
  function shard(h) {
    if (mem[h]) return mem[h];
    var ck = 'tcmnfit:' + VER + ':' + h;
    try {
      var raw = window.localStorage.getItem(ck);
      if (raw) return (mem[h] = Promise.resolve(JSON.parse(raw)));
    } catch (e) {}
    mem[h] = fetch(FILES + 'tcmnfit-' + encodeURIComponent(VER) + '-' + encodeURIComponent(h) + '.' + EXT)
      .then(function (r) { if (!r.ok) throw new Error('fit ' + r.status); return r.text(); })
      .then(function (t) {
        var d = JSON.parse(t);
        if (!d) throw new Error('fit: no shard ' + h);
        if (d.v === VER) { try { window.localStorage.setItem(ck, t); } catch (e) {} }
        return d;
      });
    mem[h].catch(function () { delete mem[h]; });
    return mem[h];
  }
  function meta() {
    return shard('meta').then(function (m) {
      if (!m._clean) {   // drop rows with a blank make or model so the picker never shows an empty choice
        Object.keys(m.models).forEach(function (k) { var p = k.split('|'); if (!p[0] || !p[1]) delete m.models[k]; });
        m._clean = true;
      }
      return m;
    });
  }

  function toItem(m, c) {
    var cids = c[7] || [];
    var img = c[5] ? (/^https?:/.test(c[5]) ? c[5] : m.img + c[5]) : '';
    return {
      id: String(c[0]), handle: c[1], title: c[2], sku: c[3], price: c[4], image: img,
      url: '/products/' + c[1], vendor: m.vendors[c[6]] || '',
      category: cids.map(function (i) { return (m.colls[i] || [])[2]; }),
      collection_ids: cids.map(function (i) { return String((m.colls[i] || [])[0]); })
    };
  }

  /* All parts and fitment rows for one make/model: { items: [], rows: [{ it, a, b, sub }] } */
  var modelCache = {};
  function model(make, mdl) {
    var key = make + '|' + mdl;
    if (modelCache[key]) return modelCache[key];
    modelCache[key] = meta().then(function (m) {
      var e = m.models[key];
      if (!e) return { items: [], rows: [] };
      return Promise.all(e.s.map(shard)).then(function (parts) {
        var items = [], rows = [];
        parts.forEach(function (d) {
          var local = d.p.map(function (c) { return toItem(m, c); });
          items = items.concat(local);
          d.f.forEach(function (f) { rows.push({ it: local[f[0]], a: f[1], b: f[2], sub: f[3] > -1 ? d.subs[f[3]] : '' }); });
        });
        return { items: items, rows: rows };
      });
    });
    modelCache[key].catch(function () { delete modelCache[key]; });
    return modelCache[key];
  }
  function vehicleItems(v) {
    var y = Number(v.year);
    return model(v.make, v.model).then(function (d) {
      var seen = {}, out = [];
      d.rows.forEach(function (r) {
        if (y < r.a || y > r.b) return;
        if (v.submodel && r.sub && r.sub !== v.submodel) return;
        if (!seen[r.it.id]) { seen[r.it.id] = 1; out.push(r.it); }
      });
      return out;
    });
  }
  var uCache = null;
  function universalItems() {
    if (uCache) return uCache;
    uCache = meta().then(function (m) {
      return Promise.all(m.u.map(shard)).then(function (parts) {
        var out = [];
        parts.forEach(function (d) { d.p.forEach(function (c) { out.push(toItem(m, c)); }); });
        return out;
      });
    });
    uCache.catch(function () { uCache = null; });
    return uCache;
  }

  /* ---------------- vehicle lists for the picker ---------------- */
  function inRuns(runs, y) { for (var i = 0; i < runs.length; i++) if (y >= runs[i][0] && y <= runs[i][1]) return true; return false; }
  function years() {
    return meta().then(function (m) {
      var set = {};
      Object.keys(m.models).forEach(function (k) {
        m.models[k].y.forEach(function (r) { for (var y = Math.max(r[0], MIN_YEAR); y <= r[1]; y++) set[y] = 1; });
      });
      return Object.keys(set).map(Number).sort(function (a, b) { return b - a; });
    });
  }
  function makes(year) {
    var y = Number(year);
    return meta().then(function (m) {
      var set = {};
      Object.keys(m.models).forEach(function (k) { if (inRuns(m.models[k].y, y)) set[k.split('|')[0]] = 1; });
      return Object.keys(set).sort();
    });
  }
  function models(year, make) {
    var y = Number(year);
    return meta().then(function (m) {
      var out = [];
      Object.keys(m.models).forEach(function (k) {
        var p = k.split('|');
        if (p[0] === make && inRuns(m.models[k].y, y)) out.push(p.slice(1).join('|'));
      });
      return out.sort(function (a, b) { return a.localeCompare(b, 'en', { numeric: true }); });
    });
  }
  function submodels(year, make, mdl) {
    var y = Number(year);
    return model(make, mdl).then(function (d) {
      var set = {};
      d.rows.forEach(function (r) { if (r.sub && y >= r.a && y <= r.b) set[r.sub] = 1; });
      return Object.keys(set).sort();
    });
  }

  /* ---------------- search (same shape as the Convermax search.json response) ---------------- */
  function words(q) { return norm(q).split(' ').filter(Boolean); }
  function matches(it, ws) {
    if (!ws.length) return true;
    var hay = ' ' + norm(it.title + ' ' + it.vendor + ' ' + brandName(it.vendor) + ' ' + (it.category || []).join(' ')) + ' ';
    var sku = squash(it.sku);
    return ws.every(function (w) { return hay.indexOf(' ' + w) > -1 || (sku && sku.indexOf(squash(w)) > -1); });
  }
  function inColl(it, cid) { return !cid || (it.collection_ids || []).indexOf(String(cid)) > -1; }
  function facet(name, counts) {
    return { FieldName: name, Values: Object.keys(counts).map(function (k) { return { Value: k, HitCount: counts[k] }; }) };
  }
  function pageOf(list, size, page) {
    size = size || 24; page = page || 0;
    return list.slice(page * size, page * size + size);
  }
  function collectionProducts(cid) {
    return meta().then(function (m) {
      var c = m.colls.filter(function (x) { return String(x[0]) === String(cid); })[0];
      if (!c) return [];
      return fetch('/collections/' + c[1] + '/products.json?limit=250').then(function (r) { return r.json(); }).then(function (d) {
        return (d.products || []).map(function (p) {
          var v = (p.variants || [])[0] || {};
          return { id: String(p.id), handle: p.handle, title: p.title, sku: v.sku || '', price: Number(v.price || 0),
            image: ((p.images || [])[0] || {}).src || '', url: '/products/' + p.handle, vendor: p.vendor, category: [], collection_ids: [String(cid)] };
        });
      });
    });
  }
  /* opts: { query, collection, vehicle, fitment: ['Vehicle Specific'|'Universal Fit'], size, page } */
  function search(opts) {
    opts = opts || {};
    var ws = words(opts.query), cid = opts.collection || '', ft = opts.fitment || [];
    var wantVS = !ft.length || ft.indexOf('Vehicle Specific') > -1;
    var wantU = !ft.length || ft.indexOf('Universal Fit') > -1;
    if (!opts.vehicle) {
      /* No truck: counts for a category come from the index; a keyword count comes from the search page. */
      return meta().then(function (m) {
        if (cid && ws.length && wantVS && !wantU) {
          return collectionProducts(cid).then(function (all) {
            var list = all.filter(function (it) { return matches(it, ws); });
            return { TotalHits: list.length, Items: pageOf(list, opts.size, opts.page), Facets: [] };
          });
        }
        if (cid && !ws.length) {
          var ix = -1;
          m.colls.forEach(function (c, i) { if (String(c[0]) === String(cid)) ix = i; });
          var s = (m.cstats || {})[ix] || [0, 0, 0, 0];
          return universalItems().then(function (u) {
            var list = wantU ? u.filter(function (it) { return inColl(it, cid); }) : [];
            return { TotalHits: wantVS && wantU ? s[0] : (wantU ? s[2] : s[1]), Items: pageOf(list, opts.size, opts.page),
              Facets: [facet('FitmentType', { 'Vehicle Specific': s[1], 'Universal Fit': s[2], 'No Fitment Data': s[3] })] };
          });
        }
        var host = document.querySelector('[data-lw-fit][data-query]');
        var total = host ? Number(host.getAttribute('data-total') || 0) : 0;
        return universalItems().then(function (u) {
          var list = wantU ? u.filter(function (it) { return inColl(it, cid) && matches(it, ws); }) : [];
          return { TotalHits: total || list.length, Items: pageOf(list, opts.size, opts.page),
            Facets: [facet('FitmentType', { 'Vehicle Specific': total || list.length, 'Universal Fit': list.length })] };
        });
      });
    }
    return Promise.all([wantVS ? vehicleItems(opts.vehicle) : [], wantU ? universalItems() : []]).then(function (r) {
      var vs = r[0].filter(function (it) { return inColl(it, cid) && matches(it, ws); });
      var u = r[1].filter(function (it) { return inColl(it, cid) && matches(it, ws); });
      var list = vs.concat(u);
      return { TotalHits: list.length, Items: pageOf(list, opts.size, opts.page),
        Facets: [facet('FitmentType', { 'Vehicle Specific': vs.length, 'Universal Fit': u.length })] };
    });
  }

  /* Answer the old Convermax search.json URL locally, so lw-fit.js and anything else keep working. */
  function fromCmUrl(url) {
    var q = new URL(url).searchParams, o = { vehicle: null, fitment: [] }, veh = {};
    o.size = Number(q.get('pagesize') || 24);
    o.page = Number(q.get('page') || 0);
    o.query = q.get('query') || '';
    for (var i = 0; i < 12; i++) {
      var f = q.get('facet.' + i + '.field');
      if (!f) continue;
      q.getAll('facet.' + i + '.selection').forEach(function (s) {
        if (f === 'collection_ids') o.collection = s;
        else if (f === 'FitmentType') o.fitment.push(s);
        else if (/^(Year|Make|Model|Submodel)$/.test(f)) veh[f.toLowerCase()] = s;
      });
    }
    if (veh.year && veh.make && veh.model) o.vehicle = { year: veh.year, make: veh.make, model: veh.model, submodel: veh.submodel || '' };
    return o;
  }
  var realFetch = window.fetch;
  if (realFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf(CM_API) === 0) {
        return search(fromCmUrl(url)).then(function (res) {
          return new Response(JSON.stringify(res), { status: 200, headers: { 'Content-Type': 'application/json' } });
        });
      }
      return realFetch.apply(this, arguments);
    };
  }

  /* ---------------- Year / Make / Model / Trim picker ---------------- */
  var uid = 0;
  function optionsHtml(list, placeholder, grouped) {
    var h = '<option value="">' + esc(placeholder) + '</option>';
    if (grouped) {
      var top = POPULAR.filter(function (x) { return list.indexOf(x) > -1; });
      var rest = list.filter(function (x) { return top.indexOf(x) < 0; });
      if (top.length && rest.length) {
        return h + '<optgroup label="Most popular">' + top.map(function (x) { return '<option value="v:' + esc(x) + '">' + esc(x) + '</option>'; }).join('') + '</optgroup>' +
          '<optgroup label="All other makes">' + rest.map(function (x) { return '<option value="v:' + esc(x) + '">' + esc(x) + '</option>'; }).join('') + '</optgroup>';
      }
    }
    /* values carry a "v:" prefix so lakewood.js's generic select scanner leaves this widget alone */
    return h + list.map(function (x) { return '<option value="v:' + esc(x) + '">' + esc(x) + '</option>'; }).join('');
  }
  function val(sel) { return sel.value ? sel.value.slice(2) : ''; }
  function setVal(sel, x) { sel.value = x ? 'v:' + x : ''; return val(sel) === String(x || ''); }

  function initPicker(box) {
    if (box.dataset.ready) return;
    box.dataset.ready = '1';
    var n = ++uid, action = box.getAttribute('data-action') || 'results';
    var f = function (k, t) {
      return '<div class="tcmn-ymm__f" data-f="' + k + '"><span class="tcmn-ymm__l" id="tcmn-ymm-' + n + '-' + k + '">' + t + '</span>' +
        '<select aria-labelledby="tcmn-ymm-' + n + '-' + k + '" data-k="' + k + '" disabled><option value="">' + t + '</option></select></div>';
    };
    box.innerHTML = '<form class="tcmn-ymm__form" novalidate>' +
      '<div class="tcmn-ymm__fields">' + f('year', 'Year') + f('make', 'Make') + f('model', 'Model') + f('sub', 'Trim / submodel') + '</div>' +
      '<div class="tcmn-ymm__actions"><button type="submit" class="tcmn-ymm__go" disabled>Pick year, make and model</button>' +
      '<button type="button" class="tcmn-ymm__clear" hidden>Clear</button></div>' +
      '<p class="tcmn-ymm__msg" hidden></p></form>';
    var form = box.querySelector('form');
    var S = {}; ['year', 'make', 'model', 'sub'].forEach(function (k) { S[k] = form.querySelector('[data-k="' + k + '"]'); });
    var go = form.querySelector('.tcmn-ymm__go'), clr = form.querySelector('.tcmn-ymm__clear'), msg = form.querySelector('.tcmn-ymm__msg');
    var subField = form.querySelector('[data-f="sub"]');

    function reset(k, t) { S[k].innerHTML = '<option value="">' + t + '</option>'; S[k].disabled = true; }
    function refreshButton() {
      var y = val(S.year), mk = val(S.make), md = val(S.model), sb = val(S.sub);
      var ready = y && mk && md;
      go.disabled = !ready;
      go.textContent = ready ? 'Show parts for my ' + [y, mk, md, sb].filter(Boolean).join(' ') : 'Pick year, make and model';
      clr.hidden = !getVehicle() && !y;
    }
    function fillSub(y, mk, md, want) {
      reset('sub', 'Trim / submodel');
      subField.classList.remove('is-none');
      if (!(y && mk && md)) return Promise.resolve();
      return submodels(y, mk, md).then(function (list) {
        if (!list.length) {
          S.sub.innerHTML = '<option value="">All trims</option>';
          subField.classList.add('is-none');
          return;
        }
        S.sub.innerHTML = optionsHtml(list, 'All trims (optional)');
        S.sub.disabled = false;
        if (want) setVal(S.sub, want);
      });
    }
    function fillModel(y, mk, want, wantSub) {
      reset('model', 'Model'); reset('sub', 'Trim / submodel');
      if (!(y && mk)) return Promise.resolve();
      return models(y, mk).then(function (list) {
        S.model.innerHTML = optionsHtml(list, 'Model');
        S.model.disabled = false;
        if (want && setVal(S.model, want)) return fillSub(y, mk, want, wantSub);
      });
    }
    function fillMake(y, want, wantModel, wantSub) {
      reset('make', 'Make'); reset('model', 'Model'); reset('sub', 'Trim / submodel');
      if (!y) return Promise.resolve();
      return makes(y).then(function (list) {
        S.make.innerHTML = optionsHtml(list, 'Make', true);
        S.make.disabled = false;
        if (want && setVal(S.make, want)) return fillModel(y, want, wantModel, wantSub);
      });
    }
    function load(v) {
      return years().then(function (list) {
        S.year.innerHTML = optionsHtml(list.map(String), 'Year');
        S.year.disabled = false;
        if (v && setVal(S.year, v.year)) return fillMake(v.year, v.make, v.model, v.submodel);
      }).then(refreshButton, function () {
        msg.hidden = false;
        msg.innerHTML = 'The truck list didn’t load. Refresh the page or call <a href="' + TEL + '">' + PHONE + '</a>.';
      });
    }
    S.year.addEventListener('change', function () { fillMake(val(S.year)).then(refreshButton); refreshButton(); });
    S.make.addEventListener('change', function () { fillModel(val(S.year), val(S.make)).then(refreshButton); refreshButton(); });
    S.model.addEventListener('change', function () { fillSub(val(S.year), val(S.make), val(S.model)).then(refreshButton); refreshButton(); });
    S.sub.addEventListener('change', refreshButton);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = { year: val(S.year), make: val(S.make), model: val(S.model), submodel: val(S.sub) };
      if (!(v.year && v.make && v.model)) return;
      setVehicle(v);
      if (action === 'results') { window.location.href = resultsUrl(v); return; }
      refreshButton();
      var target = document.querySelector('[data-lw-fit]:not([hidden])') || document.querySelector('[data-tcmn-results]');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    clr.addEventListener('click', function () {
      setVehicle(null);
      setVal(S.year, '');
      fillMake('').then(refreshButton);
    });
    document.addEventListener('lakewood:vehiclechange', function () {
      var v = getVehicle();
      if (box.contains(document.activeElement)) return refreshButton();
      if (v && (val(S.year) !== String(v.year) || val(S.make) !== v.make || val(S.model) !== v.model || val(S.sub) !== (v.submodel || ''))) load(v);
      else refreshButton();
    });
    load(getVehicle());
  }

  /* ---------------- results page (/pages/search) ---------------- */
  function vehicleFromQuery(m) {
    var p = new URLSearchParams(window.location.search);
    if (p.get('year') && p.get('make') && p.get('model')) {
      return Promise.resolve({ year: p.get('year'), make: p.get('make'), model: p.get('model'), submodel: p.get('submodel') || '' });
    }
    /* old Convermax links: /pages/search?Year/2020/Make/Ford/Model/F-150/Submodel/King-Ranch */
    var raw = decodeURIComponent(window.location.search.replace(/^\?/, ''));
    var mt = raw.match(/Year\/(\d{4})\/Make\/([^/&]+)\/Model\/([^/&]+)(?:\/Submodel\/([^/&]+))?/);
    if (!mt) return Promise.resolve(null);
    return meta().then(function (md) {
      var y = mt[1], mk = '', mo = '';
      Object.keys(md.models).forEach(function (k) {
        var p2 = k.split('|');
        if (squash(p2[0]) === squash(mt[2]) && squash(p2[1]) === squash(mt[3])) { mk = p2[0]; mo = p2[1]; }
      });
      if (!mk) return null;
      if (!mt[4]) return { year: y, make: mk, model: mo, submodel: '' };
      return submodels(y, mk, mo).then(function (subs) {
        var s = subs.filter(function (x) { return squash(x) === squash(mt[4]); })[0] || '';
        return { year: y, make: mk, model: mo, submodel: s };
      });
    });
  }
  function card(it, badge) {
    return '<article class="lw-product-card lw-product-card--next lw-fit-card">' +
      '<a class="lw-product-card__link" href="' + esc(it.url) + '">' +
      '<div class="lw-product-image"><div class="lw-product-card__badges"><span class="lw-product-card__badge' + (badge === 'Universal fit' ? ' is-muted' : '') + '">' + esc(badge) + '</span></div>' +
      (it.image ? '<img class="lw-product-card__image lw-product-card__image--primary" loading="lazy" src="' + esc(imgUrl(it.image, 600)) + '" alt="' + esc(it.title) + '">' : '') + '</div>' +
      '<div class="lw-product-info"><div class="lw-product-card__topline"><span class="lw-product-brand">' + esc(brandName(it.vendor)) + '</span>' +
      (it.sku ? '<span class="lw-product-card__sku">#' + esc(it.sku) + '</span>' : '') + '</div>' +
      '<h3 class="lw-product-title">' + esc(it.title) + '</h3>' +
      '<div class="lw-product-card__meta"><strong class="lw-product-price">' + money(it.price) + '</strong></div>' +
      '<div class="lw-product-actions"><span class="lw-btn">View product <span aria-hidden="true">&rarr;</span></span></div>' +
      '</div></a></article>';
  }
  var PRICES = [[0, 100, 'Under $100'], [100, 300, '$100 to $300'], [300, 700, '$300 to $700'], [700, 1500, '$700 to $1,500'], [1500, 1e9, '$1,500 and up']];
  function initResults(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var st = { v: null, vs: [], u: [], cat: {}, brand: {}, price: {}, fit: { vs: true, u: false }, sort: 'best', shown: 36, catQ: '' };
    var head = root.querySelector('[data-r-head]'), grid = root.querySelector('[data-r-grid]'), side = root.querySelector('[data-r-side]');
    var count = root.querySelector('[data-r-count]'), more = root.querySelector('[data-r-more]'), sortSel = root.querySelector('[data-r-sort]');
    var empty = root.querySelector('[data-r-empty]');

    function filtered(skip) {
      var list = (st.fit.vs ? st.vs : []).concat(st.fit.u ? st.u : []);
      return list.filter(function (it) {
        if (skip !== 'cat' && Object.keys(st.cat).length && !it.category.some(function (c) { return st.cat[c]; })) return false;
        if (skip !== 'brand' && Object.keys(st.brand).length && !st.brand[brandName(it.vendor)]) return false;
        if (skip !== 'price' && Object.keys(st.price).length && !PRICES.some(function (p, i) { return st.price[i] && it.price >= p[0] && it.price < p[1]; })) return false;
        return true;
      });
    }
    function sorted(list) {
      var l = list.slice();
      if (st.sort === 'price') l.sort(function (a, b) { return a.price - b.price; });
      else if (st.sort === 'price-desc') l.sort(function (a, b) { return b.price - a.price; });
      else if (st.sort === 'title') l.sort(function (a, b) { return a.title.localeCompare(b.title); });
      return l;
    }
    function group(title, key, entries, sel, opts) {
      opts = opts || {};
      if (!entries.length) return '';
      var lim = opts.limit || 999, open = st['open_' + key];
      var list = opts.filter ? entries.filter(function (e) { return norm(e[0]).indexOf(norm(opts.filter)) > -1; }) : entries;
      return '<details class="tcmn-r__facet" open><summary>' + esc(title) + '</summary>' +
        (opts.searchable ? '<input type="search" class="tcmn-r__facet-q" data-r-catq placeholder="Find a category" value="' + esc(st.catQ) + '">' : '') +
        '<ul>' + list.slice(0, open ? 999 : lim).map(function (e) {
          return '<li><label><input type="checkbox" data-r-f="' + key + '" value="' + esc(e[2] != null ? e[2] : e[0]) + '"' + (sel[e[2] != null ? e[2] : e[0]] ? ' checked' : '') + '> <span>' + esc(e[0]) + '</span> <small>' + e[1] + '</small></label></li>';
        }).join('') + '</ul>' +
        (list.length > lim && !open ? '<button type="button" class="tcmn-r__facet-more" data-r-open="' + key + '">Show all ' + list.length + '</button>' : '') +
        '</details>';
    }
    function counts(list, fn) {
      var c = {};
      list.forEach(function (it) { fn(it).forEach(function (k) { if (k) c[k] = (c[k] || 0) + 1; }); });
      return Object.keys(c).map(function (k) { return [k, c[k]]; }).sort(function (a, b) { return b[1] - a[1] || a[0].localeCompare(b[0]); });
    }
    function renderSide() {
      var cats = counts(filtered('cat'), function (it) { return it.category; });
      var brands = counts(filtered('brand'), function (it) { return [brandName(it.vendor)]; });
      var pl = filtered('price');
      var prices = PRICES.map(function (p, i) { return [p[2], pl.filter(function (it) { return it.price >= p[0] && it.price < p[1]; }).length, i]; }).filter(function (e) { return e[1]; });
      side.innerHTML =
        '<details class="tcmn-r__facet" open><summary>Fitment</summary><ul>' +
        '<li><label><input type="checkbox" data-r-fit="vs"' + (st.fit.vs ? ' checked' : '') + '> <span>Made for your truck</span> <small>' + st.vs.length + '</small></label></li>' +
        '<li><label><input type="checkbox" data-r-fit="u"' + (st.fit.u ? ' checked' : '') + '> <span>Universal fit (any truck)</span> <small>' + st.u.length + '</small></label></li>' +
        '</ul></details>' +
        group('Category', 'cat', cats, st.cat, { limit: 12, searchable: cats.length > 12, filter: st.catQ }) +
        group('Brand', 'brand', brands, st.brand, { limit: 10 }) +
        group('Price', 'price', prices, st.price) +
        ((Object.keys(st.cat).length + Object.keys(st.brand).length + Object.keys(st.price).length) ? '<button type="button" class="tcmn-r__reset" data-r-reset>Clear filters</button>' : '');
    }
    function renderGrid() {
      var list = sorted(filtered());
      count.textContent = list.length + (list.length === 1 ? ' part' : ' parts');
      grid.innerHTML = list.slice(0, st.shown).map(function (it) { return card(it, it._u ? 'Universal fit' : 'Fits your truck'); }).join('');
      more.hidden = list.length <= st.shown;
      empty.hidden = !!list.length;
      if (!list.length) {
        empty.innerHTML = '<strong>No parts match these filters for your ' + esc(label(st.v)) + '.</strong> ' +
          '<span>Clear a filter, or call us at <a href="' + TEL + '">' + PHONE + '</a> and we’ll help you find it.</span>';
      }
    }
    function render() { renderSide(); renderGrid(); }

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-r-fit]')) { st.fit[t.getAttribute('data-r-fit')] = t.checked; }
      else if (t.matches('[data-r-f]')) {
        var k = t.getAttribute('data-r-f'), bag = st[k];
        if (t.checked) bag[t.value] = 1; else delete bag[t.value];
      } else if (t.matches('[data-r-sort]')) { st.sort = t.value; }
      else return;
      st.shown = 36;
      render();
    });
    root.addEventListener('input', function (e) {
      if (!e.target.matches('[data-r-catq]')) return;
      st.catQ = e.target.value;
      var pos = e.target.selectionStart;
      renderSide();
      var q = root.querySelector('[data-r-catq]');
      if (q) { q.focus(); try { q.setSelectionRange(pos, pos); } catch (x) {} }
    });
    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-r-open],[data-r-reset],[data-r-more],[data-r-toggle]');
      if (!t) return;
      if (t.hasAttribute('data-r-toggle')) { root.classList.toggle('show-filters'); return; }
      if (t.hasAttribute('data-r-open')) st['open_' + t.getAttribute('data-r-open')] = true;
      if (t.hasAttribute('data-r-reset')) { st.cat = {}; st.brand = {}; st.price = {}; }
      if (t.hasAttribute('data-r-more')) { st.shown += 36; renderGrid(); return; }
      render();
    });

    function run(v) {
      st.v = v;
      if (!v) {
        head.innerHTML = '<h2>Select your truck</h2><p>Pick your year, make and model above and we’ll list every part we carry that fits it.</p>';
        side.innerHTML = ''; grid.innerHTML = ''; count.textContent = ''; more.hidden = true; empty.hidden = true;
        root.classList.add('is-empty');
        return;
      }
      root.classList.remove('is-empty');
      head.innerHTML = '<h2><span>' + esc(label(v)) + '</span> parts</h2>';
      grid.innerHTML = '<div class="lw-fit-loading">Finding parts for your ' + esc(label(v)) + '&hellip;</div>';
      Promise.all([vehicleItems(v), universalItems()]).then(function (r) {
        if (st.v !== v) return;
        st.vs = r[0];
        st.u = r[1].map(function (it) { var x = Object.create(it); x._u = true; return x; });
        st.cat = {}; st.brand = {}; st.price = {}; st.shown = 36;
        st.fit = { vs: true, u: !st.vs.length };
        if (!st.vs.length) {
          head.innerHTML += '<p>We don’t have parts listed for a ' + esc(label(v)) + ' yet, so here are universal parts that fit any truck. Call us at <a href="' + TEL + '">' + PHONE + '</a> and we can often source it.</p>';
        }
        render();
      }).catch(function () {
        grid.innerHTML = '<div class="lw-fit-empty"><strong>Parts didn’t load.</strong><span>Refresh the page or call <a href="' + TEL + '">' + PHONE + '</a>.</span></div>';
      });
    }
    meta().then(function () { return vehicleFromQuery(); }).then(function (v) {
      if (v) setVehicle(v);
      run(v || getVehicle());
    }).catch(function () { run(getVehicle()); });
    document.addEventListener('lakewood:vehiclechange', function () {
      var v = getVehicle();
      if (label(v) === label(st.v)) return;
      if (v) { try { window.history.replaceState(null, '', resultsUrl(v)); } catch (x) {} }
      run(v);
    });
  }

  /* ---------------- product page: does it fit my truck? ---------------- */
  function initProductFit(box) {
    var pid = box.getAttribute('data-product-id'), kind = box.getAttribute('data-kind');   // vehicle | universal | none
    var tEl = box.querySelector('[data-lw-product-fitment-title]'), cEl = box.querySelector('[data-lw-product-fitment-copy]');
    var aEl = box.querySelector('.tcmn-pfit__msg a, :scope > a'), chg = box.querySelector('.tcmn-pfit__change');
    function set(cls, t, c, link, href) {
      box.classList.remove('is-fit', 'is-nofit', 'is-unknown');
      if (cls) box.classList.add(cls);
      if (tEl) tEl.textContent = t;
      if (cEl) cEl.textContent = c;
      if (aEl) {
        aEl.innerHTML = esc(link) + ' <span aria-hidden="true">→</span>'; aEl.setAttribute('href', href || '/pages/shop-by-vehicle');
        if (chg) aEl.hidden = !href;   // the inline picker handles select / change truck
      }
      if (chg) { chg.open = !getVehicle(); chg.querySelector('summary').textContent = getVehicle() ? 'Change truck' : 'Select your truck'; }
    }
    function check() {
      var v = getVehicle();
      if (!v) { set('', 'Select your truck to confirm fit.', 'Pick your year, make and model once and every page shows what fits.', 'Select your truck'); return; }
      var lv = label(v);
      /* the index is the source of truth (it can be newer than this page's fitment field) */
      Promise.all([vehicleItems(v), universalItems()]).then(function (r) {
        var has = function (list) { return list.some(function (it) { return it.id === pid; }); };
        if (has(r[0])) set('is-fit', 'Fits your ' + lv + '.', 'This part is listed for your truck. If the title names a bed length or cab, double-check it matches yours.', 'Change truck');
        else if (has(r[1]) || kind === 'universal') set('is-fit', 'Fits your ' + lv + '.', 'Universal part: not vehicle specific, works with any truck.', 'Change truck');
        else if (kind !== 'vehicle') set('is-unknown', 'Confirm fit for your ' + lv + '.', 'This part doesn’t list vehicle fitment online yet. Call us before ordering and we’ll verify it.', 'Change truck');
        else set('is-nofit', 'Not listed for your ' + lv + '.', 'This part isn’t shown as fitting your truck. See the parts that do, or call us and we’ll double-check.', 'Shop parts for my truck', resultsUrl(v));
      }).catch(function () {
        set('is-unknown', 'Confirm fit for your ' + lv + '.', 'We couldn’t check this part automatically. Call us before ordering and we’ll verify it.', 'Change truck');
      });
    }
    check();
    document.addEventListener('lakewood:vehiclechange', check);
  }

  /* Fitment table from the product's own fitment lines */
  function parseFitment(text) {
    var rows = [], cur = null;
    String(text || '').split(/\r?\n/).forEach(function (line) {
      var m = line.match(/^(\s*-\s*|\s+)([A-Za-z]+):\s*(.*)$/);
      if (!m) return;
      if (m[1].indexOf('-') > -1) { cur = {}; rows.push(cur); }
      if (cur) cur[m[2]] = m[3].trim();
    });
    return rows.filter(function (r) { return r.Year && r.Make && r.Model; });
  }
  function initFitTable(box) {
    var src = box.querySelector('script[type="application/json"]');
    var text = '';
    try { text = JSON.parse(src.textContent) || ''; } catch (e) {}
    var rows = parseFitment(text);
    if (!rows.length) return;
    var groups = {};
    rows.forEach(function (r) {
      var k = r.Make + '|' + r.Model;
      (groups[k] = groups[k] || []).push(r);
    });
    var keys = Object.keys(groups).sort();
    var total = rows.length;
    box.innerHTML = '<details class="tcmn-fit-table"' + (total <= 12 ? ' open' : '') + '><summary><span class="lw-kicker">Vehicle fitment</span><strong>Fits ' + keys.length + (keys.length === 1 ? ' model' : ' models') + '</strong><small>Show the full list</small></summary>' +
      '<div class="tcmn-fit-table__wrap"><table><thead><tr><th>Year</th><th>Make</th><th>Model</th><th>Trim / submodel</th></tr></thead><tbody>' +
      keys.map(function (k) {
        return groups[k].sort(function (a, b) { return String(b.Year).localeCompare(String(a.Year)) || String(a.Submodel || '').localeCompare(String(b.Submodel || '')); })
          .map(function (r) { return '<tr><td>' + esc(r.Year) + '</td><td>' + esc(r.Make) + '</td><td>' + esc(r.Model) + '</td><td>' + esc(r.Submodel || 'All') + '</td></tr>'; }).join('');
      }).join('') + '</tbody></table></div></details>';
    box.hidden = false;
  }

  /* ---------------- boot ---------------- */
  window.TcmnFit = {
    version: VER, getVehicle: getVehicle, setVehicle: setVehicle, label: label, resultsUrl: resultsUrl,
    meta: meta, years: years, makes: makes, models: models, submodels: submodels,
    vehicleItems: vehicleItems, universalItems: universalItems, search: search
  };
  /* Sections built for the Convermax widget get our picker in its place:
     the fitment hub (#cm-ymm, home page and /pages/shop-by-vehicle) and the collection-page panel. */
  function mountLegacy() {
    document.querySelectorAll('#cm-ymm').forEach(function (old) {
      var d = document.createElement('div');
      d.className = 'tcmn-ymm';
      d.setAttribute('data-tcmn-ymm', '');
      d.setAttribute('data-action', 'results');
      old.parentNode.replaceChild(d, old);
    });
    document.querySelectorAll('.lw-collection-fitment__app').forEach(function (app) {
      if (app.querySelector('[data-tcmn-ymm]')) return;
      var d = document.createElement('div');
      d.className = 'tcmn-ymm tcmn-ymm--bar';
      d.setAttribute('data-tcmn-ymm', '');
      d.setAttribute('data-action', 'stay');
      app.insertBefore(d, app.firstChild);
    });
  }
  function start() {
    mountLegacy();
    document.querySelectorAll('[data-tcmn-ymm]').forEach(initPicker);
    document.querySelectorAll('[data-tcmn-results]').forEach(initResults);
    document.querySelectorAll('[data-tcmn-product-fit]').forEach(initProductFit);
    document.querySelectorAll('[data-tcmn-fit-table]').forEach(initFitTable);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
